import { on } from 'delegated-events'

const $form = document.querySelector('.donation-form')
const $submitButton = $form ? $form.querySelector('[name=action_finish]') : null
const $cardElement = document.getElementById('card-element')

const state = {
    stripe: null,
    stripeCard: null,
}

const fn = {
    init: () => {
        if ($form && $form.classList.contains('amount-step')) {
            fn.setupAmount()
        }

        if ($form && $form.classList.contains('payment-step')) {
            fn.setupPayment()
        }
    },

    setupAmount: () => {
        const $slider = $form.querySelector('input[type=range]')
        const $marks = $form.querySelector('.marks')
        const $amount = $form.querySelector('input.donation-amount-field')
        const options = JSON.parse(
            $form.querySelector('#amount-options').textContent
        )

        const setAmount = (amount) => {
            $amount.value = `$${amount}.00`
        }

        const selectedValueIndex = options.indexOf(
            parseInt($amount.value.replace('.00', '').replace('$', ''))
        )

        if (selectedValueIndex >= 0) {
            $slider.value = selectedValueIndex
        }

        options.forEach((opt, i) => {
            const activeClass = parseInt($slider.value) === i ? 'is-active' : ''

            const $mark = document.createRange().createContextualFragment(`
        <div class="mark ${activeClass}" data-index="${i}">
          $${opt}
        </div>
      `)

            $marks.appendChild($mark)
        })

        $slider.addEventListener('input', (e) => {
            const index = e.target.value
            $marks.querySelector('.is-active').classList.remove('is-active')
            $marks
                .querySelector(`[data-index="${index}"]`)
                .classList.add('is-active')

            setAmount(options[index])
        })
    },

    setupPayment: () => {
        if ($cardElement) {
            state.stripe = window.Stripe($form.dataset.stripePubKey)
            state.isRepeating = $form.querySelector(
                '[type=hidden][name=IsRepeating]'
            )
            fn.setupStripeCard()

            $form.addEventListener('submit', fn.handleSubmit)

            on('click', '[formnovalidate]', () => {
                $form.skipValidation = true
            })
        }
    },

    setupStripeCard: () => {
        const style = {
            base: {
                fontSize: '16px',
                fontFamily: 'Open Sans, sans-serif',
                color: '#2c2c2c',
                fontSmoothing: 'antialiased',
                '::placeholder': {
                    color: '#b4b4b4',
                },
            },
            invalid: {
                color: '#b9112a',
            },
        }

        const card = state.stripe.elements().create('card', { style })

        card.mount('#card-element')
        state.stripeCard = card

        card.addEventListener('change', ({ error }) => {
            const displayError = document.getElementById('card-errors')
            if (error) {
                displayError.textContent = error.message
            } else {
                displayError.textContent = ''
            }
        })
    },

    handleSubmit: (e) => {
        if (e.target.skipValidation || e.target.forceSubmit) {
            return true
        }

        e.preventDefault()

        // Handle Stripe
        $submitButton.disabled = true
        $submitButton.classList.add('btn-loading')

        state.stripe
            .createToken(state.stripeCard, {
                name: $form.querySelector('[name=CardholderName]').value,
            })
            .then((result) => {
                if (result.error) {
                    const errorElement = document.getElementById('card-errors')
                    errorElement.textContent = result.error.message
                    $submitButton.disabled = false
                    $submitButton.classList.remove('btn-loading')
                } else {
                    fn.stripeTokenHandler(result.token)
                }
            })

        return false
    },

    stripeTokenHandler: (token) => {
        const hiddenInput = document.createElement('input')
        hiddenInput.setAttribute('type', 'hidden')
        hiddenInput.setAttribute('name', 'stripeToken')
        hiddenInput.setAttribute('value', token.id)
        $form.appendChild(hiddenInput)

        $form.forceSubmit = true
        $submitButton.disabled = false
        $submitButton.click()
        $submitButton.disabled = true
    },
}

export default {
    can: () => document.body.classList.contains('pagetype-donationpage'),
    run: fn.init,
}
